<script setup lang="ts">
const country = useState('country')

onMounted(async () => {
  await callOnce(async () => {
    try {
      const response = await fetch('https://api.ipregistry.co/?key=c6yjeqjieeuzoswy');
      const payload = await response.json();
      country.value = payload.location.country.code;
    } catch (error) {
      console.warn('Failed to fetch IP location:', error);
      // Fallback: optionally set a default country
      country.value = 'US';
    }
  })
})

</script>

<template>
  <Head>
    <title>Neuronoir</title>
  </Head>
  <div>
    <NuxtLayout></NuxtLayout>
  </div>
</template>
